import './ProgressSpell.scss';

import React, { FC } from 'react';

interface ProgressSpellProps {
  isVisible: boolean;
  spellType: string;
}

const ProgressSpell: FC<ProgressSpellProps> = ({ isVisible, spellType }) => {
  if (isVisible) {
    return (
      <div
        className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
        style={{ zIndex: 1080, background: "rgba(0,0,0,.4)", backdropFilter: "blur(2px)" }}
      >
        <div className="bg-white rounded-4 shadow-lg text-center p-4 p-md-5" style={{ minWidth: 320, maxWidth: 480 }}>
          <h3 className="fw-semibold text-primary mb-4">
            Summoning {spellType}...
          </h3>

          <div className="mb-4">
            <img
              src="/whizzandra-in-progress-v2.gif"
              alt="Generating content..."
              className="img-fluid rounded"
              style={{ maxHeight: 220, objectFit: "contain" }}
            />
          </div>

          <p className="fs-5 text-muted mb-0">
            Please be patient as we conjure up some amazing content for you! ✨
          </p>
          <span className="text-muted" style={{ fontSize: '0.8rem' }}>This may take up to 1 minute to complete.</span>
        </div>
      </div>
    );
  }

  return (<>&nbsp;</>);
}

export default ProgressSpell;
